[
  {
    "callingCodes": ["93"],
    "iso": "AF",
    "iso3": "AFG",
    "printableName": "Afghanistan",
    "eu": false
  },
  {
    "callingCodes": ["358"],
    "iso": "AX",
    "iso3": "ALA",
    "printableName": "Åland Islands",
    "eu": true
  },
  {
    "callingCodes": ["355"],
    "iso": "AL",
    "iso3": "ALB",
    "printableName": "Albania",
    "eu": false
  },
  {
    "callingCodes": ["213"],
    "iso": "DZ",
    "iso3": "DZA",
    "printableName": "Algeria",
    "eu": false
  },
  {
    "callingCodes": ["1684"],
    "iso": "AS",
    "iso3": "ASM",
    "printableName": "American Samoa",
    "eu": false
  },
  {
    "callingCodes": ["376"],
    "iso": "AD",
    "iso3": "AND",
    "printableName": "Andorra",
    "eu": false
  },
  {
    "callingCodes": ["244"],
    "iso": "AO",
    "iso3": "AGO",
    "printableName": "Angola",
    "eu": false
  },
  {
    "callingCodes": ["1264"],
    "iso": "AI",
    "iso3": "AIA",
    "printableName": "Anguilla",
    "eu": false
  },
  {
    "callingCodes": ["672"],
    "iso": "AQ",
    "iso3": "ATA",
    "printableName": "Antarctica",
    "eu": false
  },
  {
    "callingCodes": ["1268"],
    "iso": "AG",
    "iso3": "ATG",
    "printableName": "Antigua and Barbuda",
    "eu": false
  },
  {
    "callingCodes": ["54"],
    "iso": "AR",
    "iso3": "ARG",
    "printableName": "Argentina",
    "eu": false
  },
  {
    "callingCodes": ["374"],
    "iso": "AM",
    "iso3": "ARM",
    "printableName": "Armenia",
    "eu": false
  },
  {
    "callingCodes": ["297"],
    "iso": "AW",
    "iso3": "ABW",
    "printableName": "Aruba",
    "eu": false
  },
  {
    "callingCodes": ["61"],
    "iso": "AU",
    "iso3": "AUS",
    "printableName": "Australia",
    "eu": false
  },
  {
    "callingCodes": ["43"],
    "iso": "AT",
    "iso3": "AUT",
    "printableName": "Austria",
    "eu": true
  },
  {
    "callingCodes": ["994"],
    "iso": "AZ",
    "iso3": "AZE",
    "printableName": "Azerbaijan",
    "eu": false
  },
  {
    "callingCodes": ["1242"],
    "iso": "BS",
    "iso3": "BHS",
    "printableName": "Bahamas",
    "eu": false
  },
  {
    "callingCodes": ["973"],
    "iso": "BH",
    "iso3": "BHR",
    "printableName": "Bahrain",
    "eu": false
  },
  {
    "callingCodes": ["880"],
    "iso": "BD",
    "iso3": "BGD",
    "printableName": "Bangladesh",
    "eu": false
  },
  {
    "callingCodes": ["1246"],
    "iso": "BB",
    "iso3": "BRB",
    "printableName": "Barbados",
    "eu": false
  },
  {
    "callingCodes": ["375"],
    "iso": "BY",
    "iso3": "BLR",
    "printableName": "Belarus",
    "eu": false
  },
  {
    "callingCodes": ["32"],
    "iso": "BE",
    "iso3": "BEL",
    "printableName": "Belgium",
    "eu": true
  },
  {
    "callingCodes": ["501"],
    "iso": "BZ",
    "iso3": "BLZ",
    "printableName": "Belize",
    "eu": false
  },
  {
    "callingCodes": ["229"],
    "iso": "BJ",
    "iso3": "BEN",
    "printableName": "Benin",
    "eu": false
  },
  {
    "callingCodes": ["1441"],
    "iso": "BM",
    "iso3": "BMU",
    "printableName": "Bermuda",
    "eu": false
  },
  {
    "callingCodes": ["975"],
    "iso": "BT",
    "iso3": "BTN",
    "printableName": "Bhutan",
    "eu": false
  },
  {
    "callingCodes": ["591"],
    "iso": "BO",
    "iso3": "BOL",
    "printableName": "Bolivia (Plurinational State of)",
    "eu": false
  },
  {
    "callingCodes": ["5997"],
    "iso": "BQ",
    "iso3": "BES",
    "printableName": "Bonaire, Sint Eustatius and Saba",
    "eu": false
  },
  {
    "callingCodes": ["387"],
    "iso": "BA",
    "iso3": "BIH",
    "printableName": "Bosnia and Herzegovina",
    "eu": false
  },
  {
    "callingCodes": ["267"],
    "iso": "BW",
    "iso3": "BWA",
    "printableName": "Botswana",
    "eu": false
  },
  {
    "callingCodes": [""],
    "iso": "BV",
    "iso3": "BVT",
    "printableName": "Bouvet Island",
    "eu": false
  },
  {
    "callingCodes": ["55"],
    "iso": "BR",
    "iso3": "BRA",
    "printableName": "Brazil",
    "eu": false
  },
  {
    "callingCodes": ["246"],
    "iso": "IO",
    "iso3": "IOT",
    "printableName": "British Indian Ocean Territory",
    "eu": false
  },
  {
    "callingCodes": [""],
    "iso": "UM",
    "iso3": "UMI",
    "printableName": "United States Minor Outlying Islands",
    "eu": false
  },
  {
    "callingCodes": ["1284"],
    "iso": "VG",
    "iso3": "VGB",
    "printableName": "Virgin Islands (British)",
    "eu": false
  },
  {
    "callingCodes": ["1 340"],
    "iso": "VI",
    "iso3": "VIR",
    "printableName": "Virgin Islands (U.S.)",
    "eu": false
  },
  {
    "callingCodes": ["673"],
    "iso": "BN",
    "iso3": "BRN",
    "printableName": "Brunei Darussalam",
    "eu": false
  },
  {
    "callingCodes": ["359"],
    "iso": "BG",
    "iso3": "BGR",
    "printableName": "Bulgaria",
    "eu": true
  },
  {
    "callingCodes": ["226"],
    "iso": "BF",
    "iso3": "BFA",
    "printableName": "Burkina Faso",
    "eu": false
  },
  {
    "callingCodes": ["257"],
    "iso": "BI",
    "iso3": "BDI",
    "printableName": "Burundi",
    "eu": false
  },
  {
    "callingCodes": ["855"],
    "iso": "KH",
    "iso3": "KHM",
    "printableName": "Cambodia",
    "eu": false
  },
  {
    "callingCodes": ["237"],
    "iso": "CM",
    "iso3": "CMR",
    "printableName": "Cameroon",
    "eu": false
  },
  {
    "callingCodes": ["1"],
    "iso": "CA",
    "iso3": "CAN",
    "printableName": "Canada",
    "eu": false
  },
  {
    "callingCodes": ["238"],
    "iso": "CV",
    "iso3": "CPV",
    "printableName": "Cabo Verde",
    "eu": false
  },
  {
    "callingCodes": ["1345"],
    "iso": "KY",
    "iso3": "CYM",
    "printableName": "Cayman Islands",
    "eu": false
  },
  {
    "callingCodes": ["236"],
    "iso": "CF",
    "iso3": "CAF",
    "printableName": "Central African Republic",
    "eu": false
  },
  {
    "callingCodes": ["235"],
    "iso": "TD",
    "iso3": "TCD",
    "printableName": "Chad",
    "eu": false
  },
  {
    "callingCodes": ["56"],
    "iso": "CL",
    "iso3": "CHL",
    "printableName": "Chile",
    "eu": false
  },
  {
    "callingCodes": ["86"],
    "iso": "CN",
    "iso3": "CHN",
    "printableName": "China",
    "eu": false
  },
  {
    "callingCodes": ["61"],
    "iso": "CX",
    "iso3": "CXR",
    "printableName": "Christmas Island",
    "eu": false
  },
  {
    "callingCodes": ["61"],
    "iso": "CC",
    "iso3": "CCK",
    "printableName": "Cocos (Keeling) Islands",
    "eu": false
  },
  {
    "callingCodes": ["57"],
    "iso": "CO",
    "iso3": "COL",
    "printableName": "Colombia",
    "eu": false
  },
  {
    "callingCodes": ["269"],
    "iso": "KM",
    "iso3": "COM",
    "printableName": "Comoros",
    "eu": false
  },
  {
    "callingCodes": ["242"],
    "iso": "CG",
    "iso3": "COG",
    "printableName": "Congo",
    "eu": false
  },
  {
    "callingCodes": ["243"],
    "iso": "CD",
    "iso3": "COD",
    "printableName": "Congo (Democratic Republic of the)",
    "eu": false
  },
  {
    "callingCodes": ["682"],
    "iso": "CK",
    "iso3": "COK",
    "printableName": "Cook Islands",
    "eu": false
  },
  {
    "callingCodes": ["506"],
    "iso": "CR",
    "iso3": "CRI",
    "printableName": "Costa Rica",
    "eu": false
  },
  {
    "callingCodes": ["385"],
    "iso": "HR",
    "iso3": "HRV",
    "printableName": "Croatia",
    "eu": true
  },
  {
    "callingCodes": ["53"],
    "iso": "CU",
    "iso3": "CUB",
    "printableName": "Cuba",
    "eu": false
  },
  {
    "callingCodes": ["599"],
    "iso": "CW",
    "iso3": "CUW",
    "printableName": "Curaçao",
    "eu": false
  },
  {
    "callingCodes": ["357"],
    "iso": "CY",
    "iso3": "CYP",
    "printableName": "Cyprus",
    "eu": true
  },
  {
    "callingCodes": ["420"],
    "iso": "CZ",
    "iso3": "CZE",
    "printableName": "Czech Republic",
    "eu": true
  },
  {
    "callingCodes": ["45"],
    "iso": "DK",
    "iso3": "DNK",
    "printableName": "Denmark",
    "eu": true
  },
  {
    "callingCodes": ["253"],
    "iso": "DJ",
    "iso3": "DJI",
    "printableName": "Djibouti",
    "eu": false
  },
  {
    "callingCodes": ["1767"],
    "iso": "DM",
    "iso3": "DMA",
    "printableName": "Dominica",
    "eu": false
  },
  {
    "callingCodes": ["1809", "1829", "1849"],
    "iso": "DO",
    "iso3": "DOM",
    "printableName": "Dominican Republic",
    "eu": false
  },
  {
    "callingCodes": ["593"],
    "iso": "EC",
    "iso3": "ECU",
    "printableName": "Ecuador",
    "eu": false
  },
  {
    "callingCodes": ["20"],
    "iso": "EG",
    "iso3": "EGY",
    "printableName": "Egypt",
    "eu": false
  },
  {
    "callingCodes": ["503"],
    "iso": "SV",
    "iso3": "SLV",
    "printableName": "El Salvador",
    "eu": false
  },
  {
    "callingCodes": ["240"],
    "iso": "GQ",
    "iso3": "GNQ",
    "printableName": "Equatorial Guinea",
    "eu": false
  },
  {
    "callingCodes": ["291"],
    "iso": "ER",
    "iso3": "ERI",
    "printableName": "Eritrea",
    "eu": false
  },
  {
    "callingCodes": ["372"],
    "iso": "EE",
    "iso3": "EST",
    "printableName": "Estonia",
    "eu": true
  },
  {
    "callingCodes": ["251"],
    "iso": "ET",
    "iso3": "ETH",
    "printableName": "Ethiopia",
    "eu": false
  },
  {
    "callingCodes": ["500"],
    "iso": "FK",
    "iso3": "FLK",
    "printableName": "Falkland Islands (Malvinas)",
    "eu": false
  },
  {
    "callingCodes": ["298"],
    "iso": "FO",
    "iso3": "FRO",
    "printableName": "Faroe Islands",
    "eu": false
  },
  {
    "callingCodes": ["679"],
    "iso": "FJ",
    "iso3": "FJI",
    "printableName": "Fiji",
    "eu": false
  },
  {
    "callingCodes": ["358"],
    "iso": "FI",
    "iso3": "FIN",
    "printableName": "Finland",
    "eu": true
  },
  {
    "callingCodes": ["33"],
    "iso": "FR",
    "iso3": "FRA",
    "printableName": "France",
    "eu": true
  },
  {
    "callingCodes": ["594"],
    "iso": "GF",
    "iso3": "GUF",
    "printableName": "French Guiana",
    "eu": true
  },
  {
    "callingCodes": ["689"],
    "iso": "PF",
    "iso3": "PYF",
    "printableName": "French Polynesia",
    "eu": false
  },
  {
    "callingCodes": [""],
    "iso": "TF",
    "iso3": "ATF",
    "printableName": "French Southern Territories",
    "eu": false
  },
  {
    "callingCodes": ["241"],
    "iso": "GA",
    "iso3": "GAB",
    "printableName": "Gabon",
    "eu": false
  },
  {
    "callingCodes": ["220"],
    "iso": "GM",
    "iso3": "GMB",
    "printableName": "Gambia",
    "eu": false
  },
  {
    "callingCodes": ["995"],
    "iso": "GE",
    "iso3": "GEO",
    "printableName": "Georgia",
    "eu": false
  },
  {
    "callingCodes": ["49"],
    "iso": "DE",
    "iso3": "DEU",
    "printableName": "Germany",
    "eu": true
  },
  {
    "callingCodes": ["233"],
    "iso": "GH",
    "iso3": "GHA",
    "printableName": "Ghana",
    "eu": false
  },
  {
    "callingCodes": ["350"],
    "iso": "GI",
    "iso3": "GIB",
    "printableName": "Gibraltar",
    "eu": true
  },
  {
    "callingCodes": ["30"],
    "iso": "GR",
    "iso3": "GRC",
    "printableName": "Greece",
    "eu": true
  },
  {
    "callingCodes": ["299"],
    "iso": "GL",
    "iso3": "GRL",
    "printableName": "Greenland",
    "eu": false
  },
  {
    "callingCodes": ["1473"],
    "iso": "GD",
    "iso3": "GRD",
    "printableName": "Grenada",
    "eu": false
  },
  {
    "callingCodes": ["590"],
    "iso": "GP",
    "iso3": "GLP",
    "printableName": "Guadeloupe",
    "eu": false
  },
  {
    "callingCodes": ["1671"],
    "iso": "GU",
    "iso3": "GUM",
    "printableName": "Guam",
    "eu": false
  },
  {
    "callingCodes": ["502"],
    "iso": "GT",
    "iso3": "GTM",
    "printableName": "Guatemala",
    "eu": false
  },
  {
    "callingCodes": ["44"],
    "iso": "GG",
    "iso3": "GGY",
    "printableName": "Guernsey",
    "eu": false
  },
  {
    "callingCodes": ["224"],
    "iso": "GN",
    "iso3": "GIN",
    "printableName": "Guinea",
    "eu": false
  },
  {
    "callingCodes": ["245"],
    "iso": "GW",
    "iso3": "GNB",
    "printableName": "Guinea-Bissau",
    "eu": false
  },
  {
    "callingCodes": ["592"],
    "iso": "GY",
    "iso3": "GUY",
    "printableName": "Guyana",
    "eu": false
  },
  {
    "callingCodes": ["509"],
    "iso": "HT",
    "iso3": "HTI",
    "printableName": "Haiti",
    "eu": false
  },
  {
    "callingCodes": [""],
    "iso": "HM",
    "iso3": "HMD",
    "printableName": "Heard Island and McDonald Islands",
    "eu": false
  },
  {
    "callingCodes": ["379"],
    "iso": "VA",
    "iso3": "VAT",
    "printableName": "Holy See",
    "eu": false
  },
  {
    "callingCodes": ["504"],
    "iso": "HN",
    "iso3": "HND",
    "printableName": "Honduras",
    "eu": false
  },
  {
    "callingCodes": ["852"],
    "iso": "HK",
    "iso3": "HKG",
    "printableName": "Hong Kong",
    "eu": false
  },
  {
    "callingCodes": ["36"],
    "iso": "HU",
    "iso3": "HUN",
    "printableName": "Hungary",
    "eu": true
  },
  {
    "callingCodes": ["354"],
    "iso": "IS",
    "iso3": "ISL",
    "printableName": "Iceland",
    "eu": false
  },
  {
    "callingCodes": ["91"],
    "iso": "IN",
    "iso3": "IND",
    "printableName": "India",
    "eu": false
  },
  {
    "callingCodes": ["62"],
    "iso": "ID",
    "iso3": "IDN",
    "printableName": "Indonesia",
    "eu": false
  },
  {
    "callingCodes": ["225"],
    "iso": "CI",
    "iso3": "CIV",
    "printableName": "Côte d'Ivoire",
    "eu": false
  },
  {
    "callingCodes": ["98"],
    "iso": "IR",
    "iso3": "IRN",
    "printableName": "Iran (Islamic Republic of)",
    "eu": false
  },
  {
    "callingCodes": ["964"],
    "iso": "IQ",
    "iso3": "IRQ",
    "printableName": "Iraq",
    "eu": false
  },
  {
    "callingCodes": ["353"],
    "iso": "IE",
    "iso3": "IRL",
    "printableName": "Ireland",
    "eu": true
  },
  {
    "callingCodes": ["44"],
    "iso": "IM",
    "iso3": "IMN",
    "printableName": "Isle of Man",
    "eu": true
  },
  {
    "callingCodes": ["972"],
    "iso": "IL",
    "iso3": "ISR",
    "printableName": "Israel",
    "eu": false
  },
  {
    "callingCodes": ["39"],
    "iso": "IT",
    "iso3": "ITA",
    "printableName": "Italy",
    "eu": true
  },
  {
    "callingCodes": ["1876"],
    "iso": "JM",
    "iso3": "JAM",
    "printableName": "Jamaica",
    "eu": false
  },
  {
    "callingCodes": ["81"],
    "iso": "JP",
    "iso3": "JPN",
    "printableName": "Japan",
    "eu": false
  },
  {
    "callingCodes": ["44"],
    "iso": "JE",
    "iso3": "JEY",
    "printableName": "Jersey",
    "eu": false
  },
  {
    "callingCodes": ["962"],
    "iso": "JO",
    "iso3": "JOR",
    "printableName": "Jordan",
    "eu": false
  },
  {
    "callingCodes": ["76", "77"],
    "iso": "KZ",
    "iso3": "KAZ",
    "printableName": "Kazakhstan",
    "eu": false
  },
  {
    "callingCodes": ["254"],
    "iso": "KE",
    "iso3": "KEN",
    "printableName": "Kenya",
    "eu": false
  },
  {
    "callingCodes": ["686"],
    "iso": "KI",
    "iso3": "KIR",
    "printableName": "Kiribati",
    "eu": false
  },
  {
    "callingCodes": ["965"],
    "iso": "KW",
    "iso3": "KWT",
    "printableName": "Kuwait",
    "eu": false
  },
  {
    "callingCodes": ["996"],
    "iso": "KG",
    "iso3": "KGZ",
    "printableName": "Kyrgyzstan",
    "eu": false
  },
  {
    "callingCodes": ["856"],
    "iso": "LA",
    "iso3": "LAO",
    "printableName": "Lao People's Democratic Republic",
    "eu": false
  },
  {
    "callingCodes": ["371"],
    "iso": "LV",
    "iso3": "LVA",
    "printableName": "Latvia",
    "eu": true
  },
  {
    "callingCodes": ["961"],
    "iso": "LB",
    "iso3": "LBN",
    "printableName": "Lebanon",
    "eu": false
  },
  {
    "callingCodes": ["266"],
    "iso": "LS",
    "iso3": "LSO",
    "printableName": "Lesotho",
    "eu": false
  },
  {
    "callingCodes": ["231"],
    "iso": "LR",
    "iso3": "LBR",
    "printableName": "Liberia",
    "eu": false
  },
  {
    "callingCodes": ["218"],
    "iso": "LY",
    "iso3": "LBY",
    "printableName": "Libya",
    "eu": false
  },
  {
    "callingCodes": ["423"],
    "iso": "LI",
    "iso3": "LIE",
    "printableName": "Liechtenstein",
    "eu": false
  },
  {
    "callingCodes": ["370"],
    "iso": "LT",
    "iso3": "LTU",
    "printableName": "Lithuania",
    "eu": true
  },
  {
    "callingCodes": ["352"],
    "iso": "LU",
    "iso3": "LUX",
    "printableName": "Luxembourg",
    "eu": true
  },
  {
    "callingCodes": ["853"],
    "iso": "MO",
    "iso3": "MAC",
    "printableName": "Macao",
    "eu": false
  },
  {
    "callingCodes": ["389"],
    "iso": "MK",
    "iso3": "MKD",
    "printableName": "Macedonia (the former Yugoslav Republic of)",
    "eu": false
  },
  {
    "callingCodes": ["261"],
    "iso": "MG",
    "iso3": "MDG",
    "printableName": "Madagascar",
    "eu": false
  },
  {
    "callingCodes": ["265"],
    "iso": "MW",
    "iso3": "MWI",
    "printableName": "Malawi",
    "eu": false
  },
  {
    "callingCodes": ["60"],
    "iso": "MY",
    "iso3": "MYS",
    "printableName": "Malaysia",
    "eu": false
  },
  {
    "callingCodes": ["960"],
    "iso": "MV",
    "iso3": "MDV",
    "printableName": "Maldives",
    "eu": false
  },
  {
    "callingCodes": ["223"],
    "iso": "ML",
    "iso3": "MLI",
    "printableName": "Mali",
    "eu": false
  },
  {
    "callingCodes": ["356"],
    "iso": "MT",
    "iso3": "MLT",
    "printableName": "Malta",
    "eu": true
  },
  {
    "callingCodes": ["692"],
    "iso": "MH",
    "iso3": "MHL",
    "printableName": "Marshall Islands",
    "eu": false
  },
  {
    "callingCodes": ["596"],
    "iso": "MQ",
    "iso3": "MTQ",
    "printableName": "Martinique",
    "eu": false
  },
  {
    "callingCodes": ["222"],
    "iso": "MR",
    "iso3": "MRT",
    "printableName": "Mauritania",
    "eu": false
  },
  {
    "callingCodes": ["230"],
    "iso": "MU",
    "iso3": "MUS",
    "printableName": "Mauritius",
    "eu": false
  },
  {
    "callingCodes": ["262"],
    "iso": "YT",
    "iso3": "MYT",
    "printableName": "Mayotte",
    "eu": false
  },
  {
    "callingCodes": ["52"],
    "iso": "MX",
    "iso3": "MEX",
    "printableName": "Mexico",
    "eu": false
  },
  {
    "callingCodes": ["691"],
    "iso": "FM",
    "iso3": "FSM",
    "printableName": "Micronesia (Federated States of)",
    "eu": false
  },
  {
    "callingCodes": ["373"],
    "iso": "MD",
    "iso3": "MDA",
    "printableName": "Moldova (Republic of)",
    "eu": false
  },
  {
    "callingCodes": ["377"],
    "iso": "MC",
    "iso3": "MCO",
    "printableName": "Monaco",
    "eu": false
  },
  {
    "callingCodes": ["976"],
    "iso": "MN",
    "iso3": "MNG",
    "printableName": "Mongolia",
    "eu": false
  },
  {
    "callingCodes": ["382"],
    "iso": "ME",
    "iso3": "MNE",
    "printableName": "Montenegro",
    "eu": false
  },
  {
    "callingCodes": ["1664"],
    "iso": "MS",
    "iso3": "MSR",
    "printableName": "Montserrat",
    "eu": false
  },
  {
    "callingCodes": ["212"],
    "iso": "MA",
    "iso3": "MAR",
    "printableName": "Morocco",
    "eu": false
  },
  {
    "callingCodes": ["258"],
    "iso": "MZ",
    "iso3": "MOZ",
    "printableName": "Mozambique",
    "eu": false
  },
  {
    "callingCodes": ["95"],
    "iso": "MM",
    "iso3": "MMR",
    "printableName": "Myanmar",
    "eu": false
  },
  {
    "callingCodes": ["264"],
    "iso": "NA",
    "iso3": "NAM",
    "printableName": "Namibia",
    "eu": false
  },
  {
    "callingCodes": ["674"],
    "iso": "NR",
    "iso3": "NRU",
    "printableName": "Nauru",
    "eu": false
  },
  {
    "callingCodes": ["977"],
    "iso": "NP",
    "iso3": "NPL",
    "printableName": "Nepal",
    "eu": false
  },
  {
    "callingCodes": ["31"],
    "iso": "NL",
    "iso3": "NLD",
    "printableName": "Netherlands",
    "eu": true
  },
  {
    "callingCodes": ["687"],
    "iso": "NC",
    "iso3": "NCL",
    "printableName": "New Caledonia",
    "eu": false
  },
  {
    "callingCodes": ["64"],
    "iso": "NZ",
    "iso3": "NZL",
    "printableName": "New Zealand",
    "eu": false
  },
  {
    "callingCodes": ["505"],
    "iso": "NI",
    "iso3": "NIC",
    "printableName": "Nicaragua",
    "eu": false
  },
  {
    "callingCodes": ["227"],
    "iso": "NE",
    "iso3": "NER",
    "printableName": "Niger",
    "eu": false
  },
  {
    "callingCodes": ["234"],
    "iso": "NG",
    "iso3": "NGA",
    "printableName": "Nigeria",
    "eu": false
  },
  {
    "callingCodes": ["683"],
    "iso": "NU",
    "iso3": "NIU",
    "printableName": "Niue",
    "eu": false
  },
  {
    "callingCodes": ["672"],
    "iso": "NF",
    "iso3": "NFK",
    "printableName": "Norfolk Island",
    "eu": false
  },
  {
    "callingCodes": ["850"],
    "iso": "KP",
    "iso3": "PRK",
    "printableName": "Korea (Democratic People's Republic of)",
    "eu": false
  },
  {
    "callingCodes": ["1670"],
    "iso": "MP",
    "iso3": "MNP",
    "printableName": "Northern Mariana Islands",
    "eu": false
  },
  {
    "callingCodes": ["47"],
    "iso": "NO",
    "iso3": "NOR",
    "printableName": "Norway",
    "eu": false
  },
  {
    "callingCodes": ["968"],
    "iso": "OM",
    "iso3": "OMN",
    "printableName": "Oman",
    "eu": false
  },
  {
    "callingCodes": ["92"],
    "iso": "PK",
    "iso3": "PAK",
    "printableName": "Pakistan",
    "eu": false
  },
  {
    "callingCodes": ["680"],
    "iso": "PW",
    "iso3": "PLW",
    "printableName": "Palau",
    "eu": false
  },
  {
    "callingCodes": ["970"],
    "iso": "PS",
    "iso3": "PSE",
    "printableName": "Palestine, State of",
    "eu": false
  },
  {
    "callingCodes": ["507"],
    "iso": "PA",
    "iso3": "PAN",
    "printableName": "Panama",
    "eu": false
  },
  {
    "callingCodes": ["675"],
    "iso": "PG",
    "iso3": "PNG",
    "printableName": "Papua New Guinea",
    "eu": false
  },
  {
    "callingCodes": ["595"],
    "iso": "PY",
    "iso3": "PRY",
    "printableName": "Paraguay",
    "eu": false
  },
  {
    "callingCodes": ["51"],
    "iso": "PE",
    "iso3": "PER",
    "printableName": "Peru",
    "eu": false
  },
  {
    "callingCodes": ["63"],
    "iso": "PH",
    "iso3": "PHL",
    "printableName": "Philippines",
    "eu": false
  },
  {
    "callingCodes": ["64"],
    "iso": "PN",
    "iso3": "PCN",
    "printableName": "Pitcairn",
    "eu": false
  },
  {
    "callingCodes": ["48"],
    "iso": "PL",
    "iso3": "POL",
    "printableName": "Poland",
    "eu": true
  },
  {
    "callingCodes": ["351"],
    "iso": "PT",
    "iso3": "PRT",
    "printableName": "Portugal",
    "eu": true
  },
  {
    "callingCodes": ["1787", "1939"],
    "iso": "PR",
    "iso3": "PRI",
    "printableName": "Puerto Rico",
    "eu": false
  },
  {
    "callingCodes": ["974"],
    "iso": "QA",
    "iso3": "QAT",
    "printableName": "Qatar",
    "eu": false
  },
  {
    "callingCodes": ["383"],
    "iso": "XK",
    "iso3": "KOS",
    "printableName": "Republic of Kosovo",
    "eu": false
  },
  {
    "callingCodes": ["262"],
    "iso": "RE",
    "iso3": "REU",
    "printableName": "Réunion",
    "eu": false
  },
  {
    "callingCodes": ["40"],
    "iso": "RO",
    "iso3": "ROU",
    "printableName": "Romania",
    "eu": true
  },
  {
    "callingCodes": ["7"],
    "iso": "RU",
    "iso3": "RUS",
    "printableName": "Russian Federation",
    "eu": false
  },
  {
    "callingCodes": ["250"],
    "iso": "RW",
    "iso3": "RWA",
    "printableName": "Rwanda",
    "eu": false
  },
  {
    "callingCodes": ["590"],
    "iso": "BL",
    "iso3": "BLM",
    "printableName": "Saint Barthélemy",
    "eu": false
  },
  {
    "callingCodes": ["290"],
    "iso": "SH",
    "iso3": "SHN",
    "printableName": "Saint Helena, Ascension and Tristan da Cunha",
    "eu": false
  },
  {
    "callingCodes": ["1869"],
    "iso": "KN",
    "iso3": "KNA",
    "printableName": "Saint Kitts and Nevis",
    "eu": false
  },
  {
    "callingCodes": ["1758"],
    "iso": "LC",
    "iso3": "LCA",
    "printableName": "Saint Lucia",
    "eu": false
  },
  {
    "callingCodes": ["590"],
    "iso": "MF",
    "iso3": "MAF",
    "printableName": "Saint Martin (French part)",
    "eu": false
  },
  {
    "callingCodes": ["508"],
    "iso": "PM",
    "iso3": "SPM",
    "printableName": "Saint Pierre and Miquelon",
    "eu": false
  },
  {
    "callingCodes": ["1784"],
    "iso": "VC",
    "iso3": "VCT",
    "printableName": "Saint Vincent and the Grenadines",
    "eu": false
  },
  {
    "callingCodes": ["685"],
    "iso": "WS",
    "iso3": "WSM",
    "printableName": "Samoa",
    "eu": false
  },
  {
    "callingCodes": ["378"],
    "iso": "SM",
    "iso3": "SMR",
    "printableName": "San Marino",
    "eu": false
  },
  {
    "callingCodes": ["239"],
    "iso": "ST",
    "iso3": "STP",
    "printableName": "Sao Tome and Principe",
    "eu": false
  },
  {
    "callingCodes": ["966"],
    "iso": "SA",
    "iso3": "SAU",
    "printableName": "Saudi Arabia",
    "eu": false
  },
  {
    "callingCodes": ["221"],
    "iso": "SN",
    "iso3": "SEN",
    "printableName": "Senegal",
    "eu": false
  },
  {
    "callingCodes": ["381"],
    "iso": "RS",
    "iso3": "SRB",
    "printableName": "Serbia",
    "eu": false
  },
  {
    "callingCodes": ["248"],
    "iso": "SC",
    "iso3": "SYC",
    "printableName": "Seychelles",
    "eu": false
  },
  {
    "callingCodes": ["232"],
    "iso": "SL",
    "iso3": "SLE",
    "printableName": "Sierra Leone",
    "eu": false
  },
  {
    "callingCodes": ["65"],
    "iso": "SG",
    "iso3": "SGP",
    "printableName": "Singapore",
    "eu": false
  },
  {
    "callingCodes": ["1721"],
    "iso": "SX",
    "iso3": "SXM",
    "printableName": "Sint Maarten (Dutch part)",
    "eu": false
  },
  {
    "callingCodes": ["421"],
    "iso": "SK",
    "iso3": "SVK",
    "printableName": "Slovakia",
    "eu": true
  },
  {
    "callingCodes": ["386"],
    "iso": "SI",
    "iso3": "SVN",
    "printableName": "Slovenia",
    "eu": true
  },
  {
    "callingCodes": ["677"],
    "iso": "SB",
    "iso3": "SLB",
    "printableName": "Solomon Islands",
    "eu": false
  },
  {
    "callingCodes": ["252"],
    "iso": "SO",
    "iso3": "SOM",
    "printableName": "Somalia",
    "eu": false
  },
  {
    "callingCodes": ["27"],
    "iso": "ZA",
    "iso3": "ZAF",
    "printableName": "South Africa",
    "eu": false
  },
  {
    "callingCodes": ["500"],
    "iso": "GS",
    "iso3": "SGS",
    "printableName": "South Georgia and the South Sandwich Islands",
    "eu": false
  },
  {
    "callingCodes": ["82"],
    "iso": "KR",
    "iso3": "KOR",
    "printableName": "Korea (Republic of)",
    "eu": false
  },
  {
    "callingCodes": ["211"],
    "iso": "SS",
    "iso3": "SSD",
    "printableName": "South Sudan",
    "eu": false
  },
  {
    "callingCodes": ["34"],
    "iso": "ES",
    "iso3": "ESP",
    "printableName": "Spain",
    "eu": true
  },
  {
    "callingCodes": ["94"],
    "iso": "LK",
    "iso3": "LKA",
    "printableName": "Sri Lanka",
    "eu": false
  },
  {
    "callingCodes": ["249"],
    "iso": "SD",
    "iso3": "SDN",
    "printableName": "Sudan",
    "eu": false
  },
  {
    "callingCodes": ["597"],
    "iso": "SR",
    "iso3": "SUR",
    "printableName": "Suriname",
    "eu": false
  },
  {
    "callingCodes": ["4779"],
    "iso": "SJ",
    "iso3": "SJM",
    "printableName": "Svalbard and Jan Mayen",
    "eu": false
  },
  {
    "callingCodes": ["268"],
    "iso": "SZ",
    "iso3": "SWZ",
    "printableName": "Swaziland",
    "eu": false
  },
  {
    "callingCodes": ["46"],
    "iso": "SE",
    "iso3": "SWE",
    "printableName": "Sweden",
    "eu": true
  },
  {
    "callingCodes": ["41"],
    "iso": "CH",
    "iso3": "CHE",
    "printableName": "Switzerland",
    "eu": false
  },
  {
    "callingCodes": ["963"],
    "iso": "SY",
    "iso3": "SYR",
    "printableName": "Syrian Arab Republic",
    "eu": false
  },
  {
    "callingCodes": ["886"],
    "iso": "TW",
    "iso3": "TWN",
    "printableName": "Taiwan",
    "eu": false
  },
  {
    "callingCodes": ["992"],
    "iso": "TJ",
    "iso3": "TJK",
    "printableName": "Tajikistan",
    "eu": false
  },
  {
    "callingCodes": ["255"],
    "iso": "TZ",
    "iso3": "TZA",
    "printableName": "Tanzania, United Republic of",
    "eu": false
  },
  {
    "callingCodes": ["66"],
    "iso": "TH",
    "iso3": "THA",
    "printableName": "Thailand",
    "eu": false
  },
  {
    "callingCodes": ["670"],
    "iso": "TL",
    "iso3": "TLS",
    "printableName": "Timor-Leste",
    "eu": false
  },
  {
    "callingCodes": ["228"],
    "iso": "TG",
    "iso3": "TGO",
    "printableName": "Togo",
    "eu": false
  },
  {
    "callingCodes": ["690"],
    "iso": "TK",
    "iso3": "TKL",
    "printableName": "Tokelau",
    "eu": false
  },
  {
    "callingCodes": ["676"],
    "iso": "TO",
    "iso3": "TON",
    "printableName": "Tonga",
    "eu": false
  },
  {
    "callingCodes": ["1868"],
    "iso": "TT",
    "iso3": "TTO",
    "printableName": "Trinidad and Tobago",
    "eu": false
  },
  {
    "callingCodes": ["216"],
    "iso": "TN",
    "iso3": "TUN",
    "printableName": "Tunisia",
    "eu": false
  },
  {
    "callingCodes": ["90"],
    "iso": "TR",
    "iso3": "TUR",
    "printableName": "Turkey",
    "eu": false
  },
  {
    "callingCodes": ["993"],
    "iso": "TM",
    "iso3": "TKM",
    "printableName": "Turkmenistan",
    "eu": false
  },
  {
    "callingCodes": ["1649"],
    "iso": "TC",
    "iso3": "TCA",
    "printableName": "Turks and Caicos Islands",
    "eu": false
  },
  {
    "callingCodes": ["688"],
    "iso": "TV",
    "iso3": "TUV",
    "printableName": "Tuvalu",
    "eu": false
  },
  {
    "callingCodes": ["256"],
    "iso": "UG",
    "iso3": "UGA",
    "printableName": "Uganda",
    "eu": false
  },
  {
    "callingCodes": ["380"],
    "iso": "UA",
    "iso3": "UKR",
    "printableName": "Ukraine",
    "eu": false
  },
  {
    "callingCodes": ["971"],
    "iso": "AE",
    "iso3": "ARE",
    "printableName": "United Arab Emirates",
    "eu": false
  },
  {
    "callingCodes": ["44"],
    "iso": "GB",
    "iso3": "GBR",
    "printableName": "United Kingdom of Great Britain and Northern Ireland",
    "eu": false
  },
  {
    "callingCodes": ["1"],
    "iso": "US",
    "iso3": "USA",
    "printableName": "United States of America",
    "eu": false
  },
  {
    "callingCodes": ["598"],
    "iso": "UY",
    "iso3": "URY",
    "printableName": "Uruguay",
    "eu": false
  },
  {
    "callingCodes": ["998"],
    "iso": "UZ",
    "iso3": "UZB",
    "printableName": "Uzbekistan",
    "eu": false
  },
  {
    "callingCodes": ["678"],
    "iso": "VU",
    "iso3": "VUT",
    "printableName": "Vanuatu",
    "eu": false
  },
  {
    "callingCodes": ["58"],
    "iso": "VE",
    "iso3": "VEN",
    "printableName": "Venezuela (Bolivarian Republic of)",
    "eu": false
  },
  {
    "callingCodes": ["84"],
    "iso": "VN",
    "iso3": "VNM",
    "printableName": "Viet Nam",
    "eu": false
  },
  {
    "callingCodes": ["681"],
    "iso": "WF",
    "iso3": "WLF",
    "printableName": "Wallis and Futuna",
    "eu": false
  },
  {
    "callingCodes": ["212"],
    "iso": "EH",
    "iso3": "ESH",
    "printableName": "Western Sahara",
    "eu": false
  },
  {
    "callingCodes": ["967"],
    "iso": "YE",
    "iso3": "YEM",
    "printableName": "Yemen",
    "eu": false
  },
  {
    "callingCodes": ["260"],
    "iso": "ZM",
    "iso3": "ZMB",
    "printableName": "Zambia",
    "eu": false
  },
  {
    "callingCodes": ["263"],
    "iso": "ZW",
    "iso3": "ZWE",
    "printableName": "Zimbabwe",
    "eu": false
  }
]
